"use client"

import { createContext, useContext } from "react"

import type { StateInvalidationTrigger } from "@/platform/app-mode/state-invalidation"
import type { CheckoutCompletedData } from "@/platform/bridge/types"

export interface AppModeStateApi {
  readonly invalidate: (trigger: StateInvalidationTrigger) => void
  readonly postCheckoutCompleted: (completion: CheckoutCompletedData) => void
}

export const AppModeStateContext = createContext<AppModeStateApi>({ invalidate: () => {}, postCheckoutCompleted: () => {} })

export const useStateInvalidation = (): AppModeStateApi["invalidate"] => useContext(AppModeStateContext).invalidate

export const useCheckoutCompletedReport = (): AppModeStateApi["postCheckoutCompleted"] => useContext(AppModeStateContext).postCheckoutCompleted
